import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Pagination from "react-js-pagination";
import Input from "./Input";
import GatheringInfo from "./GatheringInfo";
import { close, open } from "../redux/popupSlice";
import * as APIS from "../utils/service";
import { getMemberinfo } from "../utils/utils";
import { setModalState } from "../redux/communityStepSlice";
import consts from "../libs/consts"

// 소모임 매인 화면
const GatheringManage = ({ step, setStep, setInnerStep }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { configdata } = useSelector(s => s.configReducer);

    // 기존
    // const [page, setPage] = useState(1);
    const [bigCategory, setBigCategory] = useState(0);
    const [smallCategory, setSmallCategory] = useState(0);
    const [gatheringName, setGatheringName] = useState("");

    const [goDetail, setGoDetail] = useState(false); // 신청 페이지
    const [chooseGathering, setChooseGathering] = useState({}); // 선택한 그룹 정보

    const [isSearchPage, setIsSearchPage] = useState(false) // 검색 상태
    const [searchPage, setSearchPage] = useState(1);
    // 작업
    const [memberinfos, setmemberinfos] = useState({}); // 로그인된 사용자 정보
    const [myGroupList, setMyGroupList] = useState([]); // 운영그룹리스트
    const [recommendGroupList, setRecommendGroupList] = useState([]); // 추천그룹리스트
    const [joinGroupList, setJoinGroupList] = useState([]); // 소속그룹리스트
    const [searchList, setSearchList] = useState([]); // 검색결과

    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(4);


    const handlePageChange = (pageNumber) => {
        setPage(pageNumber)
    };
    const handleSearchPageChange = (pageNumber) => {
        setSearchPage(pageNumber)
    }

    const toggleStar = (g_idx) => {
        APIS.postData('/v1/communityGroup/setFav', {
            idx: g_idx
        }).then(({ data }) => {
            loadJoinGroup()
            loadMyGroup()
        }).catch(({ response }) => {
            const { data } = response;
            messagePopup(data?.msg || "즐겨찾기를 추가할 수 없습니다.")
        })
    };

    // 카테고리 이름 변경 
    const cateToName = (type = 1, idx = 1) => {
        if (type === 1) {
            let findCate = configdata?.consts?.communityCategory1?.find(v => v?.idx == idx);
            if (findCate) {
                return findCate?.title
            }
        } else if (type === 2) {
            let findCate = configdata?.consts?.communityCategory2?.find(v => v?.idx == idx);
            if (findCate) {
                return findCate?.title
            }
        }
        return ""
    }

    // 신규 소모임 신청
    const makeGroupClick = () => {
        APIS.postData('/v1/communityGroup/insertCheck', {}).then(({ data }) => {
            if (data) {
                setStep(2) // 신청화면
                setInnerStep(1)
            } else {
                APIS.postData('/v1/communityGroup/get', {}).then(({ data }) => {
                    if (data?.status === 9) {
                        setStep(2)
                        setInnerStep(1, data)
                    } else {
                        setStep(2)
                        setInnerStep(2) // 처리화면
                    }
                }).catch(({ response }) => {
                    const { data } = response;
                    messagePopup(data?.msg || "잠시후 다시 시도해주세요.")
                })

            }
        }).catch(({ response }) => {
            const { data } = response;
            messagePopup(data?.msg || "잠시후 다시 시도해주세요.")
        })
    }

    // 운영중인 그룹 로드
    const loadMyGroup = () => {
        APIS.postData('/v1/communityGroup/myList', {}).then(({ data }) => {
            setMyGroupList(data)
        }).catch(({ response }) => {
            setMyGroupList([])
        })
    }

    // 추천 그룹
    const loadRecommendGroup = () => {
        let senders = {}
        APIS.postData('/v1/communityGroup/recommend', senders).then(({ data }) => {
            setRecommendGroupList(data)
        }).catch(({ response }) => {
            setRecommendGroupList([])
        })
    }

    // 가입된 그룹
    const loadJoinGroup = () => {
        let senders = {
            type: 1,
        }
        APIS.postData('/v1/communityGroup/list', senders).then(({ data }) => {
            data.sort((a, b) => b.isFav - a.isFav);
            setJoinGroupList(data)
            setTotalCount(data?.length)
        }).catch(({ response }) => {
            setJoinGroupList([])
        })
    }

    const pageFilter = (data, index) => {
        let sIndex = (page - 1) * limit
        let eIndex = sIndex + limit
        return (index >= sIndex && index < eIndex)
    }

    const searchPageFilter = (data, index) => {
        let sIndex = (searchPage - 1) * limit
        let eIndex = sIndex + limit
        return (index >= sIndex && index < eIndex)
    }

    // 검색
    const searchFunc = () => {
        setSearchList([]);
        setSearchPage(1);
        setIsSearchPage(true);

        let sender = {
            type: 2,
            cate1: bigCategory,
            cate2: smallCategory,
            title: gatheringName,
        }

        APIS.postData('/v1/communityGroup/list', sender).then(({ data }) => {
            setSearchList(data)
        }).catch(({ response }) => {
            setSearchList([])
        })
    }

    // 폐쇄
    const groupDeleteFunc = (g_idx, name = "") => {
        let sender = {
            idx: g_idx
        }
        dispatch(
            open({
                component: `${name} 소모임을 폐쇄하시겠습니까?`,
                title: "알림",
                button: "예",
                buttonCencle: "아니오",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                    dispatch(
                        open({
                            component: `소모임을 삭제하시면 복구할 수 없습니다.
정말 폐쇄하시겠습니까?`,
                            title: "알림",
                            button: "예",
                            buttonCencle: "아니오",
                            titleviewer: true,
                            alert: false,
                            onPress: () => {
                                dispatch(close());
                                loadMyGroup();
                                APIS.postData('/v1/communityGroup/delete', sender).then(({ data }) => {
                                    loadMyGroup();
                                    messagePopup(`${name} 폐쇄가 완료되었습니다.`)
                                }).catch(({ response }) => {
                                    const { data } = response;
                                    messagePopup(data?.msg || "잠시후 다시 시도하세요.")
                                })
                            },
                            onCancelPress: () => {
                                dispatch(close());
                            },
                        })
                    );
                },
                onCancelPress: () => {
                    dispatch(close());
                },
            })
        );
    }

    // 그룹 탈퇴
    const groupExitFunc = (group) => {
        let sender = {
            idx: group?.idx
        }

        dispatch(
            open({
                component: group?.title + "에서 정말 탈퇴하시겠습니까?",
                title: "알림",
                button: "탈퇴",
                buttonCencle: "취소",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                    APIS.postData('/v1/communityGroup/exit', sender).then(({ data }) => {
                        loadJoinGroup();
                        messagePopup("탈퇴 되었습니다.")
                    }).catch(({ response }) => {
                        const { data } = response;
                        messagePopup(data?.msg || "잠시후 다시 시도하세요.")
                    })
                },
                onCancelPress: () => {
                    dispatch(close());
                },
            })
        );
    }

    const messagePopup = (msg) => {
        dispatch(
            open({
                component: msg,
                title: '알림',
                button: "확인",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(close());
                },
            })
        );
    }

    useEffect(() => {
        getMemberinfo(setmemberinfos);
        loadMyGroup();
        loadRecommendGroup();
        loadJoinGroup();
    }, [])

    return (
        <>
            {goDetail && <GatheringInfo setStep={setStep} setGoDetail={(v) => {
                if (!v) {
                    loadMyGroup();
                    loadRecommendGroup();
                    loadJoinGroup();
                }
                setGoDetail(v)
            }} data={chooseGathering} />}
            {!goDetail && (
                <div className="community_modal_scroll">
                    <div className="community_modal_white_wrap">
                        <div className="community_modal_white">
                            <div className="community_modal_line_wrap">
                                <p
                                    style={{
                                        fontWeight: 700,
                                        fontSize: "20px",
                                        width: "100px",
                                    }}
                                >
                                    카테고리
                                </p>
                                <div className="community_modal_line">
                                    <div className="custom-select">
                                        <select
                                            value={bigCategory}
                                            onChange={(e) => {
                                                setBigCategory(Number(e.target.value));
                                            }}
                                        >
                                            <option value={0}>{"전체"}</option>
                                            {configdata?.consts?.communityCategory1?.map(v => {
                                                return <option value={v?.idx}>
                                                    {v?.title}
                                                </option>
                                            })}
                                        </select>
                                    </div>
                                    <div className="custom-select">
                                        <select
                                            value={smallCategory}
                                            onChange={(e) => {
                                                setSmallCategory(Number(e.target.value));
                                            }}
                                        >
                                            <option value={0}>{"전체"}</option>
                                            {configdata?.consts?.communityCategory2?.filter(v => v?.category1 == bigCategory)?.map(v => {
                                                return <option value={v?.idx}>
                                                    {v?.title}
                                                </option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="community_modal_line_wrap">
                                <p style={{
                                    fontWeight: 700,
                                    fontSize: "20px",
                                    width: "100px",
                                }}>
                                    소모임명
                                </p>
                                <div className="community_modal_line">
                                    <Input
                                        className="inputs"
                                        type="text"
                                        value={gatheringName}
                                        setValue={setGatheringName}
                                        submitfunc={searchFunc}
                                    />
                                </div>
                            </div>
                            <div className="bottom_btn_wrap">
                                <button className="register" onClick={searchFunc}>검색</button>
                                {isSearchPage && <button className="cancel" onClick={() => { setIsSearchPage(false) }}>처음으로</button>}
                            </div>
                        </div>
                    </div>

                    {!isSearchPage && <>
                        {/* 운영중 소모임 */}
                        <div className="community_modal_gray_wrap">
                            <div className="title">운영중인 소모임</div>
                            <div className="community_modal_grid">
                                {myGroupList?.map((data, index) => {
                                    return (
                                        <div className="community_modal_content_div">
                                            <div className="title">
                                                <p>
                                                    {cateToName(1, data?.cate1)}-
                                                    {cateToName(2, data?.cate2)}
                                                </p>
                                                {data?.status === 2 && <div
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() =>
                                                        toggleStar(data?.idx)
                                                    }
                                                >
                                                    {data?.isFav ?
                                                        <img src={`./images/icons/star_line_on.svg`} /> :
                                                        <img src={`./images/icons/star_line_off.svg`} />}
                                                </div>}
                                            </div>
                                            <div className="lineWidth"></div>
                                            <div
                                                className="community_content_wrap"
                                                onClick={() => {
                                                    // 운영상태 > 게시판 이동
                                                    if (data?.status === 2) {
                                                        dispatch(setModalState(false));
                                                        navigate(`/GatheringBoard?group=${data?.idx}`);
                                                    }
                                                }}
                                            >
                                                <div className="community_content_img">
                                                    {data?.thumb && <img src={consts.s3url + "/" + data?.thumb} />}
                                                </div>
                                                <div className="community_content">
                                                    <div className="header">
                                                        <div className={`${data?.status === 2 ? "" : data?.status === 1 ? "grey" : "red"}`}>
                                                            {
                                                                data?.status === 2 ?
                                                                    "운영" :
                                                                    data?.status === 1 ? "검토중" :
                                                                        data?.status === 9 ? "등록 거절" : "비운영"
                                                            }
                                                        </div>
                                                        <p>{data?.title}</p>
                                                    </div>
                                                    <div>{data?.userCount}/{data?.max_count}</div>
                                                    <div>
                                                        {data?.desc}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="btn_wrap">
                                                <button
                                                    className="purple"
                                                    onClick={() => {
                                                        if (data?.status === 2) {
                                                            setStep(4)
                                                            dispatch(setModalState({
                                                                modalState: true,
                                                                groupData: data,
                                                            }));
                                                        } else if (data?.status === 9) {
                                                            setStep(2)
                                                            setInnerStep(3) // 처리화면 상태
                                                        } else if (data?.status === 1) {
                                                            setStep(2)
                                                            setInnerStep(3) // 처리화면 상태
                                                        }
                                                    }}
                                                >
                                                    {data?.status === 9 ? "재신청" : "소모임 관리"}
                                                </button>
                                                <button onClick={() => {
                                                    if (data?.status === 2) {
                                                        groupDeleteFunc(data?.idx, data?.title)
                                                    }
                                                }}>폐쇄</button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {/* 추천 소모임 */}
                        <div className="community_modal_white_wrap">
                            <div className="white_search_header">
                                <div className="title">
                                    <p>추천 소모임</p>
                                    <img
                                        style={{ cursor: "pointer" }}
                                        src={`./images/icons/loop-left-line-purple.svg`}
                                        onClick={() => { loadRecommendGroup() }}
                                    />
                                </div>
                                <div onClick={makeGroupClick}>
                                    신규 소모임 신청
                                </div>
                            </div>
                            <div className="community_modal_grid">
                                {recommendGroupList?.map((data, i) => {
                                    return (
                                        <div className="community_modal_content_div">
                                            <div className="title">
                                                <p>
                                                    {cateToName(1, data?.cate1)}-
                                                    {cateToName(2, data?.cate2)}
                                                </p>

                                            </div>
                                            <div className="lineWidth"></div>
                                            <div
                                                className="community_content_wrap"
                                                onClick={() => {
                                                    setGoDetail(true);
                                                    setStep(3);
                                                    setChooseGathering(data);
                                                }}
                                            >
                                                <div className="community_content_img">
                                                    {data?.thumb && <img src={consts.s3url + "/" + data?.thumb} />}
                                                </div>
                                                <div className="community_content">
                                                    <div className="header">
                                                        {/* <div className={`${data?.status === 2 ? "" : data?.status === 1 ? "grey" : "red"}`}>
                                                            {data?.status === 2 ? "운영" : data?.status === 1 ? "검토중" : "비운영"}
                                                        </div> */}
                                                        <p>{data?.title}</p>
                                                    </div>
                                                    <div>{data?.userCount}/{data?.max_count}</div>
                                                    <div>
                                                        {data?.desc}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {/* 가입된 소모임 */}
                        <div className="community_modal_white_wrap">
                            <div className="white_header_wrap">
                                <p>가입된 소모임</p>
                                <p>
                                    즐겨찾기로 추가하면 메인 게시판 목록에
                                    표시됩니다.(최대 5개까지 등록 가능)
                                </p>
                            </div>
                            <div className="community_modal_grid">
                                {joinGroupList?.filter(pageFilter)?.map((data, i) => {
                                    return (
                                        <div className="community_modal_content_div">
                                            <div className="title">
                                                <p>
                                                    {cateToName(1, data?.cate1)}-
                                                    {cateToName(2, data?.cate2)}
                                                </p>
                                                <div
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() =>
                                                        toggleStar(data?.idx)
                                                    }
                                                >
                                                    {data?.isFav ?
                                                        <img src={`./images/icons/star_line_on.svg`} /> :
                                                        <img src={`./images/icons/star_line_off.svg`} />}
                                                </div>
                                            </div>
                                            <div className="lineWidth"></div>
                                            <div
                                                className="community_content_wrap"
                                                onClick={() => {
                                                    //운영일때 게시판으로 이동
                                                    if (data?.status === 2) {
                                                        dispatch(setModalState(false));
                                                        navigate(`/GatheringBoard?group=${data?.idx}`);
                                                    }
                                                }}
                                            >
                                                <div className="community_content_img">
                                                    {data?.thumb && <img src={consts.s3url + "/" + data?.thumb} />}
                                                </div>
                                                <div className="community_content">
                                                    <div className="header">
                                                        {memberinfos?.idx == data?.u_idx && <div className={`${data?.status === 2 ? "" : data?.status === 1 ? "grey" : "red"}`}>
                                                            {data?.status === 2 ? "운영" : data?.status === 1 ? "검토중" : "비운영"}
                                                        </div>}

                                                        <p>{data?.title}</p>
                                                    </div>
                                                    <div>{data?.userCount}/{data?.max_count}</div>
                                                    <div>
                                                        {data?.desc}
                                                    </div>
                                                </div>
                                            </div>
                                            {memberinfos?.idx == data?.u_idx ? <div className="btn_wrap">
                                                <button
                                                    className="purple"
                                                    onClick={() => {
                                                        setStep(4)
                                                        dispatch(setModalState({
                                                            modalState: true,
                                                            groupData: data,
                                                        }));
                                                    }}
                                                >
                                                    소모임 관리
                                                </button>
                                                <button onClick={() => {
                                                    groupDeleteFunc(data?.idx, data?.title)
                                                }}>폐쇄</button>
                                            </div> : <div className="btn_wrap">
                                                <button onClick={() => {
                                                    groupExitFunc(data)
                                                }}>탈퇴</button>
                                            </div>}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="community_modal_white_wrap">
                            <div className="PaginationContent">
                                <Pagination
                                    className="my-pagination"
                                    // 현제 보고있는 페이지
                                    activePage={page}
                                    // 한페이지에 출력할 아이템수
                                    itemsCountPerPage={limit}
                                    // 총 아이템수
                                    totalItemsCount={totalCount}
                                    // 표시할 페이지수
                                    pageRangeDisplayed={10}
                                    // 함수
                                    onChange={handlePageChange}
                                    nextPageText=""
                                    prevPageText=""
                                    firstPageText=""
                                    lastPageText=""
                                />
                            </div>
                        </div>
                    </>}



                    {isSearchPage && <>
                        <div className="community_modal_white_wrap" style={{ minHeight: 320 }}>
                            <div className="white_header_wrap">
                                <p>검색결과</p>
                                <p></p>
                            </div>
                            <div className="community_modal_grid">
                                {searchList?.filter(searchPageFilter)?.map((data, i) => {
                                    return (
                                        <div className="community_modal_content_div">
                                            <div className="title">
                                                <p>{cateToName(1, data?.cate1)}-{cateToName(2, data?.cate2)}</p>
                                            </div>
                                            <div className="lineWidth"></div>
                                            <div
                                                className="community_content_wrap"
                                                onClick={() => {
                                                    // 가입창
                                                    setGoDetail(true);
                                                    setStep(3);
                                                    setChooseGathering(data);
                                                }}
                                            >
                                                <div className="community_content_img">
                                                    {data?.thumb && <img src={consts.s3url + "/" + data?.thumb} />}
                                                </div>
                                                <div className="community_content">
                                                    <div className="header">
                                                        {memberinfos?.idx == data?.u_idx && <div className={`${data?.status === 2 ? "" : data?.status === 1 ? "grey" : "red"}`}>
                                                            {data?.status === 2 ? "운영" : data?.status === 1 ? "검토중" : "비운영"}
                                                        </div>}
                                                        {/* <div className={`${data?.status === 2 ? "" : data?.status === 1 ? "grey" : "red"}`}>
                                                            {data?.status === 2 ? "운영" : data?.status === 1 ? "검토중" : "비운영"}
                                                        </div> */}
                                                        <p>{data?.title}</p>
                                                    </div>
                                                    <div>{data?.userCount}/{data?.max_count}</div>
                                                    <div>
                                                        {data?.desc}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                {searchList?.length < 1 && <p>검색결과가 없습니다.</p>}
                            </div>
                        </div>
                        <div className="community_modal_white_wrap">
                            <div className="PaginationContent">
                                <Pagination
                                    className="my-pagination"
                                    activePage={searchPage}
                                    itemsCountPerPage={limit}
                                    totalItemsCount={searchList?.length}
                                    pageRangeDisplayed={10}
                                    onChange={handleSearchPageChange}
                                    nextPageText=""
                                    prevPageText=""
                                    firstPageText=""
                                    lastPageText=""
                                />
                            </div>
                        </div>
                    </>}
                </div >
            )}
        </>
    );
};
export default GatheringManage;
